import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
    OrganizationDocumentResponseDto
} from '../schemas/organization-document-response.dto';
import {
    UploadOrganizationDocumentRequestDto
} from '../schemas/upload-organization-document-request.dto';
import {
    UploadOrganizationLogoRequestDto
} from '../schemas/upload-organization-logo-request.dto';
import { TRADGINE_DATA_API_BASE_URL } from '../api-base-url.token';
import { OrganizationResponseDto } from '../schemas/organization-response.dto';

@Injectable({ providedIn: 'root' })
export class OrganizationDocumentAdminApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(TRADGINE_DATA_API_BASE_URL)}/OrganizationDocumentAdmin`;

    getAll(organizationId: number) {
        return this.builder
            .url(`${this.controllerUrl}/GetAll`)
            .get()
            .json<OrganizationDocumentResponseDto[]>()
            .withHttpParams(new HttpParams().set('organizationId', organizationId))
            .build()
            .send();
    }

    getById(organizationDocumentId: number) {
        return this.builder
            .url(`${this.controllerUrl}/GetById`)
            .get()
            .json<OrganizationDocumentResponseDto>()
            .withHttpParams(new HttpParams().set('id', organizationDocumentId))
            .build()
            .send();
    }

    upload(file: File, request: UploadOrganizationDocumentRequestDto) {
        const formData = new FormData();

        formData.append('file', file);
        formData.append('organizationId', request.organizationId.toString());

        if (request.description != null) {
            formData.append('description', request.description);
        }

        if (request.name != null) {
            formData.append('name', request.name);
        }

        return this.builder
            .url(`${this.controllerUrl}/Upload`)
            .post(formData)
            .json<OrganizationDocumentResponseDto>()
            .build()
            .send();
    }

    uploadLogo(file: File, request: UploadOrganizationLogoRequestDto) {
        const formData = new FormData();

        formData.append('file', file);
        formData.append('organizationId', request.organizationId.toString());

        if (request.description != null) {
            formData.append('description', request.description);
        }

        if (request.name != null) {
            formData.append('name', request.name);
        }

        return this.builder
            .url(`${this.controllerUrl}/UploadLogo`)
            .put(formData)
            .json<OrganizationResponseDto>()
            .build()
            .send();
    }

    deleteLogo(organizationId: number) {
        return this.builder
            .url(`${this.controllerUrl}/DeleteLogo`)
            .delete()
            .text()
            .withHttpParams(new HttpParams().set('organizationId', organizationId))
            .build()
            .send();
    }

    delete(organizationDocumentId: number) {
        return this.builder
            .url(`${this.controllerUrl}/Delete`)
            .delete()
            .text()
            .withHttpParams(new HttpParams().set('id', organizationDocumentId))
            .build()
            .send();
    }
}
